<template>
  <b-modal ref="maintanancemodemodal" centered :lazy="true" title="Maintanance mode" @shown="loadIntialState" no-fade>
    <b-form class="maint-mode" no-fade>
      <div class="site-name-cont">
        <label>Site:</label>
        {{site.name}}
      </div>
      <b-form-group label="Maintenance Mode" class="maintainance_mode_radio">
        <b-form-radio-group id="radios1" v-model="form.mode" :options="options" name="radioOpenions">
        </b-form-radio-group>
      </b-form-group>
      <b-form-group label="Maintenance HTML">
        <b-form-textarea id="textarea1" v-model="form.html" placeholder="Enter something" :rows="3" :max-rows="6">
        </b-form-textarea>
      </b-form-group>

    </b-form>
    <div slot="modal-footer" class="w-100">
      <div class="text-right">
        <b-btn variant="flat" @click="close">
          Cancel
        </b-btn>
        <b-btn variant="primary" @click="sendMaintenceAction()">
          Save Changes
          <spinner size="small" v-if="isButtonLoading"></spinner>
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'maintenancemode',
  props: ['site'],

  data() {
    return {
      isButtonLoading: false,
      options: [{ text: 'Off', value: '0' }, { text: 'On', value: '1' }],
      form: {
        mode: '0',
        html: `<!doctype html>
<html>
	<head>
		<meta charset="UTF-8">
		<title>Website under maintenance</title>
		<link href="http://fonts.googleapis.com/css?family=Vollkorn" rel="stylesheet" type="text/css">
	</head>
	<body>
		<div style="font-family: 'Vollkorn', serif; font-size: 50px; text-shadow: 1px 1px 0 rgba(255, 255, 255, 0.8), 2px 2px 2px rgba(0, 0, 0, 0.15)   ; color: #000; text-align:center; margin:150px 0 10px; text-rendering: optimizeLegibility; letter-spacing: -2px;">We will be back soon.</div>
		<div style="font-family:Gotham, 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 16px; color: #888; text-align:center;">We are updating more awesome content for you.</div>
	</body>
</html>`
      }
    };
  },

  methods: {
    loadIntialState() {
      
      Object.assign(this.$data, this.$options.data.apply(this));
      if (this.site.connectionStatus == '2') {
        this.form.mode = 1;
      }
    },
    sendMaintenceAction() {
      this.isButtonLoading = true;
      let payload = {};
      payload.action = 'iwpMaintenance';

      payload.args = {};
      payload.args.params = {
        mcheck: this.form.mode,
        mHTML_b64encoded: btoa(this.form.html)
      };
      payload.args.siteIDs = [];
      payload.args.siteIDs.push(this.site.siteID);
      payload.requiredData = {
        iwpMaintenance: 1,
        getSitesV3: 1
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        this.isButtonLoading = true;
        this.$store.commit('SET_SITES', response.data.getSitesV3);
        this.close();
      });
    },
    close() {
      this.$refs.maintanancemodemodal.hide();
    }
  }
};
</script>

<style scoped>

</style>
